<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "TeacherIndex",
};
</script>

<style></style>
